import React from 'react';

const ToolsTab = ({ settings, toggleTool, openWebhookModal, testWebhook, formatDate, loading }) => {
  const channels = [
    { id: 'whatsapp', name: 'WhatsApp',  icon: '💬', color: '#25D366' },
    { id: 'instagram', name: 'Instagram', icon: '📸', color: '#E4405F' },
    { id: 'web_chat', name: 'Web Chat',  icon: '🌐', color: '#6366f1' }
  ];

  return (
    <div className="tools-tab">
      {/* AI Tools */}
      <div className="tt-card">
        <div className="tt-card-header">
          <div>
            <h3>🛠️ AI Araçları</h3>
            <p className="tt-sub">Asistanın kullanabileceği yetenekleri yönetin</p>
          </div>
          <div className="tt-tools-count">
            <span className="tt-active-tools">{settings.tools?.filter(t => t.enabled).length || 0}</span>
            <span className="tt-total-tools">/ {settings.tools?.length || 0} aktif</span>
          </div>
        </div>

        <div className="tt-tools-grid">
          {settings.tools?.map(tool => (
            <div key={tool.id} className={`tt-tool-card ${tool.enabled ? 'enabled' : ''}`}>
              <div className="tt-tool-left">
                <div className={`tt-tool-indicator ${tool.enabled ? 'on' : 'off'}`} />
                <div>
                  <div className="tt-tool-name">{tool.name.replace(/_/g, ' ')}</div>
                  <div className="tt-tool-desc">{tool.description || 'AI aracı'}</div>
                </div>
              </div>
              <label className="tt-switch">
                <input type="checkbox" checked={tool.enabled} onChange={() => toggleTool(tool)} />
                <span className="tt-slider" />
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Channel Integrations */}
      <div className="tt-card">
        <div className="tt-card-header">
          <div>
            <h3>🔗 Kanal Entegrasyonları</h3>
            <p className="tt-sub">Müşteri iletişim kanallarını bağlayın</p>
          </div>
        </div>

        <div className="tt-channels-grid">
          {channels.map(ch => {
            const webhook = settings.webhooks?.find(w => w.channel === ch.id);
            const isActive = webhook?.is_active;
            return (
              <div key={ch.id} className="tt-channel-card" style={{ '--ch-color': ch.color }}>
                <div className="tt-ch-header">
                  <div className="tt-ch-icon" style={{ background: `${ch.color}18`, border: `1px solid ${ch.color}33` }}>
                    {ch.icon}
                  </div>
                  <div className="tt-ch-info">
                    <div className="tt-ch-name">{ch.name}</div>
                    <div className={`tt-ch-status ${isActive ? 'active' : 'inactive'}`}>
                      {isActive ? '● Bağlı' : '○ Bağlı Değil'}
                    </div>
                  </div>
                </div>

                {webhook && (
                  <div className="tt-ch-meta">
                    Son test: {webhook.last_test_at ? formatDate(webhook.last_test_at) : 'Hiç test edilmedi'}
                  </div>
                )}

                <div className="tt-ch-actions">
                  {webhook ? (
                    <>
                      <button className="tt-ch-btn test" onClick={() => testWebhook(ch.id)} disabled={loading}>
                        🧪 Test
                      </button>
                      <button className="tt-ch-btn edit" onClick={() => openWebhookModal(ch.id)}>
                        ✏️ Düzenle
                      </button>
                    </>
                  ) : (
                    <button className="tt-ch-btn connect" style={{ background: `${ch.color}`, borderColor: ch.color }} onClick={() => openWebhookModal(ch.id)}>
                      🔌 Bağlantı Kur
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* VoIP Settings */}
      <div className="tt-card">
        <div className="tt-card-header">
          <div>
            <h3>📞 VoIP / SIP Konfigürasyonu</h3>
            <p className="tt-sub">Telefon entegrasyonu için SIP ayarları</p>
          </div>
        </div>

        <div className="tt-voip-grid">
          <div className="tt-field">
            <label>SIP Server</label>
            <input className="tt-input" placeholder="sip.example.com" defaultValue={settings.sip_server || ''} />
          </div>
          <div className="tt-field">
            <label>SIP Port</label>
            <input className="tt-input" placeholder="5060" defaultValue={settings.sip_port || ''} />
          </div>
          <div className="tt-field">
            <label>Kullanıcı Adı</label>
            <input className="tt-input" placeholder="username" defaultValue={settings.sip_username || ''} />
          </div>
          <div className="tt-field">
            <label>Şifre</label>
            <input className="tt-input" type="password" placeholder="••••••••" defaultValue={settings.sip_password || ''} />
          </div>
        </div>

        <div style={{ marginTop: 20 }}>
          <button className="tt-save-btn">💾 SIP Ayarlarını Kaydet</button>
        </div>
      </div>

      <style>{`
        .tools-tab { display:flex; flex-direction:column; gap:20px; }

        .tt-card { background:rgba(17,17,24,0.7); border:1px solid rgba(255,255,255,0.07); border-radius:18px; padding:24px; backdrop-filter:blur(16px); }
        .tt-card-header { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:20px; }
        .tt-card-header h3 { margin:0 0 2px; font-size:17px; font-weight:700; color:#F9FAFB; }
        .tt-sub { margin:0; font-size:13px; color:#6B7280; }
        .tt-tools-count { text-align:right; }
        .tt-active-tools { font-size:22px; font-weight:800; color:#34D399; }
        .tt-total-tools { font-size:13px; color:#6B7280; }

        .tt-tools-grid { display:grid; grid-template-columns:repeat(auto-fill, minmax(280px,1fr)); gap:10px; }
        .tt-tool-card { display:flex; justify-content:space-between; align-items:center; padding:16px 18px; background:rgba(255,255,255,0.03); border:1px solid rgba(255,255,255,0.07); border-radius:12px; transition:all 0.2s; gap:12px; }
        .tt-tool-card.enabled { background:rgba(52,211,153,0.06); border-color:rgba(52,211,153,0.2); }
        .tt-tool-left { display:flex; align-items:center; gap:12px; flex:1; min-width:0; }
        .tt-tool-indicator { width:8px; height:8px; border-radius:50%; flex-shrink:0; }
        .tt-tool-indicator.on { background:#34D399; box-shadow:0 0 8px rgba(52,211,153,0.6); }
        .tt-tool-indicator.off { background:#374151; }
        .tt-tool-name { font-size:14px; font-weight:600; color:#E5E7EB; text-transform:capitalize; }
        .tt-tool-desc { font-size:12px; color:#6B7280; margin-top:2px; }

        /* Toggle Switch */
        .tt-switch { position:relative; display:inline-block; width:44px; height:24px; flex-shrink:0; }
        .tt-switch input { opacity:0; width:0; height:0; }
        .tt-slider { position:absolute; cursor:pointer; inset:0; background:rgba(255,255,255,0.1); border:1px solid rgba(255,255,255,0.1); border-radius:24px; transition:0.3s; }
        .tt-slider:before { position:absolute; content:""; height:16px; width:16px; left:3px; bottom:3px; background:#fff; border-radius:50%; transition:0.3s; }
        input:checked + .tt-slider { background:rgba(52,211,153,0.25); border-color:rgba(52,211,153,0.5); }
        input:checked + .tt-slider:before { transform:translateX(20px); background:#34D399; }

        /* Channel Cards */
        .tt-channels-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:14px; }
        .tt-channel-card { background:rgba(255,255,255,0.03); border:1px solid rgba(255,255,255,0.07); border-radius:16px; padding:20px; display:flex; flex-direction:column; gap:14px; transition:all 0.2s; }
        .tt-channel-card:hover { border-color:var(--ch-color, rgba(255,255,255,0.15))40; }
        .tt-ch-header { display:flex; align-items:center; gap:12px; }
        .tt-ch-icon { width:48px; height:48px; border-radius:13px; display:flex; align-items:center; justify-content:center; font-size:24px; }
        .tt-ch-name { font-size:15px; font-weight:700; color:#E5E7EB; margin-bottom:3px; }
        .tt-ch-status { font-size:12px; font-weight:600; }
        .tt-ch-status.active { color:#34D399; }
        .tt-ch-status.inactive { color:#6B7280; }
        .tt-ch-meta { font-size:12px; color:#4B5563; }
        .tt-ch-actions { display:flex; gap:8px; }
        .tt-ch-btn { padding:8px 14px; border-radius:9px; font-size:12px; font-weight:600; cursor:pointer; transition:all 0.2s; border:1px solid; }
        .tt-ch-btn.test { background:rgba(96,165,250,0.1); border-color:rgba(96,165,250,0.2); color:#60A5FA; }
        .tt-ch-btn.test:disabled { opacity:0.5; cursor:not-allowed; }
        .tt-ch-btn.edit { background:rgba(167,139,250,0.1); border-color:rgba(167,139,250,0.2); color:#a78bfa; }
        .tt-ch-btn.connect { border:none; color:#fff; font-size:13px; padding:9px 16px; font-weight:700; border-radius:10px; }
        .tt-ch-btn:hover:not(:disabled) { opacity:0.8; transform:translateY(-1px); }

        /* VoIP */
        .tt-voip-grid { display:grid; grid-template-columns:repeat(2,1fr); gap:14px; }
        .tt-field { display:flex; flex-direction:column; gap:6px; }
        .tt-field label { font-size:11px; font-weight:700; color:#6B7280; text-transform:uppercase; letter-spacing:0.05em; }
        .tt-input { padding:11px 14px; background:rgba(255,255,255,0.05); border:1px solid rgba(255,255,255,0.08); border-radius:10px; color:#E5E7EB; font-size:14px; outline:none; transition:border-color 0.2s; }
        .tt-input:focus { border-color:rgba(96,165,250,0.4); }
        .tt-save-btn { padding:11px 24px; background:linear-gradient(135deg,#1d4ed8,#60A5FA); border:none; border-radius:10px; color:#fff; font-size:14px; font-weight:700; cursor:pointer; transition:all 0.2s; }
        .tt-save-btn:hover { transform:translateY(-1px); box-shadow:0 6px 20px rgba(29,78,216,0.4); }

        @media (max-width:800px) {
          .tt-channels-grid { grid-template-columns:1fr; }
          .tt-voip-grid { grid-template-columns:1fr; }
        }
      `}</style>
    </div>
  );
};

export default ToolsTab;
